// extracted by mini-css-extract-plugin
module.exports = {"time":"styles_time__2MmlF","stats":"styles_stats__VziO4","div":"styles_div__2hjSz"};